var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_184_1",
    "data-name": "Componente 184 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170797",
    "data-name": "Grupo 170797",
    transform: "translate(-842 -410)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_296",
    "data-name": "Elipse 296",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(848 416)",
    fill: "#00b836"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5778",
    "data-name": "Grupo 5778",
    transform: "translate(837.397 403.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_223",
    "data-name": "Trazado 223",
    d: "M956.809,1525.623c4.053,0,7.4-2.662,7.939-6.117a.6.6,0,0,0-.772-.667,20.321,20.321,0,0,1-14.334,0,.6.6,0,0,0-.772.668C949.4,1522.96,952.755,1525.623,956.809,1525.623Z",
    transform: "translate(-920.098 -1475.006)",
    fill: "#005d00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5777",
    "data-name": "Grupo 5777",
    transform: "translate(21.603 26.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5775",
    "data-name": "Grupo 5775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_224",
    "data-name": "Trazado 224",
    d: "M898.136,1379.544a5.8,5.8,0,0,0-1.7-.632,4.736,4.736,0,0,0-1.832-.016,4.306,4.306,0,0,0-1.694.705,6.675,6.675,0,0,0-1.42,1.323l-.039.045a.729.729,0,0,1-1.132-.916,8.211,8.211,0,0,1,1.663-1.743,5.965,5.965,0,0,1,2.246-1.093,6.519,6.519,0,0,1,2.5-.133,7.55,7.55,0,0,1,2.415.753.991.991,0,0,1-.9,1.768l-.054-.029Z",
    transform: "translate(-890.167 -1377.021)",
    fill: "#005d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_225",
    "data-name": "Trazado 225",
    d: "M911.929,1431.161a3.6,3.6,0,0,1,3.179,2.574.2.2,0,0,0,.384-.066v-.011c0-2.569-1.6-4.651-3.562-4.651s-3.562,2.082-3.562,4.651v.011a.2.2,0,0,0,.384.066A3.6,3.6,0,0,1,911.929,1431.161Z",
    transform: "translate(-906.146 -1422.665)",
    fill: "#005d00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5776",
    "data-name": "Grupo 5776",
    transform: "translate(20.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_226",
    "data-name": "Trazado 226",
    d: "M1060.359,1377.838a7.55,7.55,0,0,1,2.415-.753,6.518,6.518,0,0,1,2.5.133,5.966,5.966,0,0,1,2.246,1.093,8.207,8.207,0,0,1,1.663,1.743.729.729,0,0,1-1.13.918l-.041-.047a6.677,6.677,0,0,0-1.42-1.323,4.306,4.306,0,0,0-1.694-.705,4.736,4.736,0,0,0-1.832.016,5.8,5.8,0,0,0-1.7.632l-.052.031a.991.991,0,0,1-1.01-1.707Z",
    transform: "translate(-1059.816 -1377.021)",
    fill: "#005d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_227",
    "data-name": "Trazado 227",
    d: "M1064.793,1431.161a3.6,3.6,0,0,0-3.179,2.574.2.2,0,0,1-.384-.066v-.011c0-2.569,1.595-4.651,3.563-4.651s3.563,2.082,3.563,4.651v.011a.2.2,0,0,1-.384.066A3.6,3.6,0,0,0,1064.793,1431.161Z",
    transform: "translate(-1061.058 -1422.665)",
    fill: "#005d00"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_148768",
    "data-name": "Rect\\xE1ngulo 148768",
    width: 64,
    height: 64,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.8235bed5fae13198fb54966f8095677f.svg";
export { ForwardRef as ReactComponent };